import purchaseService from "../../services/purchaseService";
import Vue from 'vue'
import {distinctById} from "../../utils";
import axios from "axios";

var places_request;

const state = {
    purchases: [],
    loading_purchases: true,
    next_page: 1,
    opened_purchase_id: null,
    filters: {
        state: 'W',
        categories: '',
        view: 'hide_unpaid',
        place: false,
    },
    locked: localStorage.getItem('locked') === 'true',
};

const getters = {
    opened_purchase(state) {
        return state.purchases.find(obj => obj.id === parseInt(state.opened_purchase_id))||{}
    }
}

const actions = {
    getTotalMarketPurchase(store, params) {
        return new Promise((resolve, reject) => {
            purchaseService.totalMarketPurchase(params)
                .then(data => {
                    // commit('setTotalMarketPurchase', {purchase_id: params.purchase_id, total: data})
                    resolve(data);
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить итоги рынка закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getLineTotalMarketPurchase(store, params) {
        return new Promise((resolve, reject) => {
            purchaseService.lineTotalMarketPurchase(params)
                .then(data => {
                    // commit('setTotalMarketPurchase', {purchase_id: params.purchase_id, total: data})
                    resolve(data);
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить итоги линии рынка закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getTotalPurchase({commit}, purchase_id) {
        return new Promise((resolve, reject) => {
            purchaseService.totalPurchase(purchase_id)
                .then(data => {
                    commit('setTotalPurchase', {purchase_id, total: data})
                    resolve();
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить итоги закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getPlaces({commit}, purchase_id) {

		if (places_request) {
			places_request.cancel();
		}
        const CancelToken = axios.CancelToken;
		places_request = CancelToken.source();

        return new Promise((resolve, reject) => {
            purchaseService.getPlaces(purchase_id, places_request.token)
                .then(data => {
                    resolve()
                    commit('setPlaces', {data, id: purchase_id})
                })
                .catch(error => {
					if (error.__CANCEL__) {
						return
					}
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список точек закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    reject();
                })
        })
    },
    getAllowPlaces(store, purchase_id) {
        return new Promise((resolve, reject) => {
            purchaseService.getAllowPlaces(purchase_id)
                .then(places => {
                    resolve(places)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список точек закупки доступных для добавления заказа.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getPurchases({commit}) {
        state.loading_purchases = true;
        return new Promise((resolve, reject) => {
            purchaseService.fetchPurchases(state.next_page)
                .then(data => {
                    resolve();
                    let purchases = state.purchases.concat(data.results);
                    purchases = distinctById(purchases)
                    commit('setPurchases', {next: data.next, purchases});
                    state.loading_purchases = false;
                })
                .catch(error => {

                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список закупок.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });

                    state.loading_purchases = false;
                    reject();
                })
        });
    },
    getPurchase({commit, state}, purchase_id) {
        state.loading_purchases = true;
        return new Promise((resolve, reject) => {
            // const index = state.purchases.findIndex(obj => obj.id === parseInt(purchase_id))
            // if (index !== -1) {
            //     state.loading_purchases = false;
            //     resolve();
            //     return;
            // }
            purchaseService.getPurchase(purchase_id)
                .then(purchase => {
                    resolve();
                    commit('setPurchase', purchase);
                    state.loading_purchases = false;
                })
                .catch(error => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о закупке.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.loading_purchases = false;
                })
        })
    },
    addPurchase({commit}, purchase) {
        return new Promise((resolve, reject) => {
            purchaseService.postPurchase(purchase)
                .then(purchase => {
                    resolve();
                    commit('addPurchase', purchase);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить закупку.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    recalculationPercent(store, data) {
        return new Promise((resolve, reject) => {
            purchaseService.recalculationPercent(data)
                .then(response => {
                    resolve(response);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось пересчитать процент заказов закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    editPurchase({commit}, purchase) {
        return new Promise((resolve, reject) => {
            purchaseService.editPurchase(purchase)
                .then(purchase => {
                    resolve();
                    commit('editPurchase', purchase);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить закупку.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    deletePurchase({commit}, purchase_id) {
        return new Promise((resolve, reject) => {
            purchaseService.deletePurchase(purchase_id)
                .then(() => {
                    resolve();
                    commit('deletePurchase', purchase_id);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить закупку.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    },
    togglePinPurchase({commit}, purchase_id) {
        return new Promise((resolve, reject) => {
            purchaseService.togglePinPurchase(purchase_id)
                .then((purchase) => {
                    resolve();
                    commit('editPurchase', purchase);
                })
                .catch((error) => {
                    reject();
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось закрепить закупку на главной странице.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                });
        });
    }
}

const mutations = {
    setTotalPurchase(state, {purchase_id, total}) {
        let purchase = state.purchases.find(obj => obj.id === purchase_id);
        if (purchase !== undefined) {
            Vue.set(purchase, 'total', total);
        }
    },
    // setTotalMarketPurchase(state, {purchase_id, total}) {
    //     let purchase = state.purchases.find(obj => obj.id === parseInt(purchase_id));
    //     console.log(purchase)
    //     if (purchase !== undefined) {
    //         Vue.set(purchase, 'total_market', total);
    //     }
    // },
    addPurchase(state, purchase) {
        if (state.purchases.indexOf(purchase) === -1) {
            state.purchases.unshift(purchase);
        }
    },
    editPurchase(state, purchase) {
        const index = state.purchases.findIndex(obj => obj.id === purchase.id);
        if (index !== -1) {
            Vue.set(state.purchases, index, purchase);
        }
    },
    deletePurchase(state, purchase_id) {
        const index = state.purchases.findIndex(obj => obj.id === purchase_id);
        if (index !== -1) {
            state.purchases.splice(index, 1);
        }
    },
    setPurchases(state, {next, purchases}) {
        if (next) {
            state.next_page += 1;
        } else {
            state.next_page = null;
        }
        state.purchases = purchases
    },
    setPurchase(state, purchase) {
        const index = state.purchases.findIndex(obj => obj.id === purchase.id)
        if (index === -1) {
            state.purchases.push(purchase);
        } else {
            Vue.set(state.purchases, index, purchase);
        }
    },
    clearData(state) {
        state.next_page = 1;
        state.purchases = []
    },
    setOpenedPurchase(state, id) {
        state.opened_purchase_id = id;
    },
    setPlaces(state, {data, id}) {
        if (typeof (data) === 'object') {
            const index = state.purchases.findIndex(obj => obj.id === parseInt(id));
            if (index !== -1) {
                Vue.set(state.purchases[index], 'places', data);
            }
        }
    },
    updatePlaces(state, {data, id}) {
        const index = state.purchases.findIndex(obj => obj.id === parseInt(id));
        if (index !== -1) {
            Vue.set(state.purchases[index], 'places', data);
        }
    },
    setPlace(state, place) {
        Vue.set(state.filters, 'place', place)
    },
    refreshFilters(state) {
        state.filters = {
            state: 'W',
            categories: '',
            place: false,
            view: 'hide_unpaid'
        };
    },
    setFilters(state, filters) {
        if (filters.state !== undefined) {
            state.filters.state = filters.state;
        }
        if (filters.categories !== undefined) {
            state.filters.categories = filters.categories;
        }
        if (filters.place !== undefined) {
            state.filters.place = filters.place;
        }
        if (filters.view !== undefined) {
            state.filters.view = filters.view;
        }
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}